import { render, staticRenderFns } from "./SplitContainer3.vue?vue&type=template&id=ef5ff142"
import script from "./SplitContainer3.vue?vue&type=script&lang=js"
export * from "./SplitContainer3.vue?vue&type=script&lang=js"
import style0 from "./SplitContainer3.vue?vue&type=style&index=0&id=ef5ff142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports